<template>
    <div class="DataUpdate">
        <modal name="MetaModal" width="80%" height="auto" :scrollable="true" :adaptive="true" :clickToClose="false"
            style="overflow:scroll">
            <div class="tabcontent">
                <ValidationObserver ref="obsFieldsUpdate">
                    <FormupdateMetas :FieldsForm="formUpdate" :ModelForm="formUpdModel" :method="executeProcess"
                        v-if="renderComponent2" />
                </ValidationObserver>
                <div class="botonPnrocess">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-8"></div>
                            <div class="col-md-2" v-if="isNew === false">
                                <button id="updatePeriod" type="submit" v-on:click="updatePeriod"
                                    class="loginbtn primaryBtn">Actualizar
                                </button>
                            </div>
                            <div class="col-md-2" v-else-if="isNew === true">
                                <button id="AddProgram" type="submit" v-on:click="AddProgram"
                                    class="loginbtn primaryBtn">Guardar</button>
                            </div>
                            <div class="col-md-2">
                                <button id="CancelUser" type="submit" v-on:click="CancelUser"
                                    class="loginbtn primaryBtn">Cancelar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <div class="titlePage">Administración - Metas Ibero</div>
        <va-notification color="info" v-if="addRExito" class="refNoData">Se creo correctamente el programa
            solicitado.</va-notification>
        <va-notification color="info" v-if="UpdRExito" class="refNoData">Se actualizo correctamente el programa
            solicitado.</va-notification>
        <va-notification color="danger" v-if="refNoUpdate" class="refNoData">La actualizacion del programa presento un
            fallo.</va-notification>
        <va-notification color="danger" v-if="refWSUpdate" class="refNoData">El servicio que ejecuta la actualización no se
            encuentra activo.</va-notification>

        <ValidationObserver ref="obsFieldsSearch">
            <FormSearchMeta :FieldsForm="formSearch" :ModelForm="formSchModel" :method="executeProcess" />
        </ValidationObserver>
        <va-notification color="danger" id="refNoData" class="refNoData noShow">No se encontró información del programa
            solicitado.</va-notification>
        <div class="listPrograms">
            <DataTableMeta :InfoView="this.DLMetas" :HeadTable="this.HDMeta" :method="processData"
                v-if="renderComponent1" />
        </div>
    </div>
</template>

<script>
// eslint-disable-next-line import/no-duplicates
import FormSearchMeta from '@/components/forms/Forms.vue'
import FormupdateMetas from '@/components/forms/Forms.vue'
// eslint-disable-next-line import/no-duplicates
import IberoHelpers from '@/store/helpers.js'
// Data Table.
import DataTableMeta from '@/components/data-tables/DataGoals.vue'

export default {
    name: 'dataUpdate',
    components: {
        FormSearchMeta,
        FormupdateMetas,
        DataTableMeta,
    },
    data() {
        return {
            formSchModel: {},
            formSearch: [
                {
                    id: 'Sch_Button',
                    type: 'button',
                    placeholder: 'Consultar Meta',
                    class: 'col-md-3',
                },
                {
                    id: 'Sch_ButtonNew',
                    type: 'button',
                    placeholder: 'Crear Meta',
                    class: 'col-md-3',
                },
            ],
            formUpdModel: {
                id: '',
                Periodo: '',
                codigoPrograma: '',
                Entradas: '',
                Mes: '',
                Ano: '',
                TipoEstudiante: '',
                Numero_Estudiante: '',
                Valor_Facturado: '',
                Valor_Promedio: '',
            },

            formUpdate: [
                {
                    id: 'periodo',
                    model: 'Periodo',
                    name: 'Periodo',
                    type: 'input',
                    placeholder: 'Periodo',
                    values: '',
                    validate: {
                        required: true,
                        regex: '^([a-zA-z]?)',
                        max: 6,
                    },
                    class: 'col-md-4',
                },
                {
                    id: 'codigoPrograma',
                    model: 'codigoPrograma',
                    name: 'Codigo de Programa',
                    type: 'input',
                    placeholder: 'Codigo de programa',
                    class: 'col-md-4',
                    validate: {
                        required: true,
                    },
                },
                {
                    id: 'entradas',
                    model: 'Entradas',
                    name: 'Entradas',
                    type: 'input',
                    placeholder: 'Entradas',
                    class: 'col-md-4',
                    validate: {
                        required: true,
                    },
                },

                {
                    id: 'mes',
                    model: 'Mes',
                    name: 'Mes',
                    type: 'Select',
                    values: [
                        { id: '01', value: 'Enero' },
                        { id: '02', value: 'Febrero' },
                        { id: '03', value: 'Marzo' },
                        { id: '04', value: 'Abril' },
                        { id: '05', value: 'Mayo' },
                        { id: '06', value: 'Junio' },
                        { id: '07', value: 'Julio' },
                        { id: '08', value: 'Agosto' },
                        { id: '09', value: 'Septiembre' },
                        { id: '10', value: 'Octubre' },
                        { id: '11', value: 'Noviembre' },
                        { id: '12', value: 'Diciembre' },
                    ],
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },

                {
                    id: 'ano',
                    model: 'Ano',
                    name: 'Año',
                    type: 'input',
                    placeholder: 'Año',
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },

                {
                    id: 'tipoEstudiante',
                    model: 'TipoEstudiante',
                    name: 'Tipo de Estudiante',
                    type: 'Select',
                    placeholder: 'Seleccione el Tipo de Estudiante',
                    values: [
                        { id: 'NUEVO', value: 'NUEVO' },
                        { id: 'ANTIGUO', value: 'ANTIGUO' },
                    ],
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },

                {
                    id: 'numero_Estudiante',
                    model: 'Numero_Estudiante',
                    name: 'Numero de Estudiante',
                    type: 'input',
                    placeholder: 'Numero de Estudiante',
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },

                {
                    id: 'valor_Facturado',
                    model: 'Valor_Facturado',
                    name: 'Valor Facturado',
                    type: 'input',
                    placeholder: 'Valor Facturado',
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },

                {
                    id: 'valor_Promedio',
                    model: 'Valor_Promedio',
                    name: 'Valor Promedio',
                    type: 'input',
                    placeholder: 'Valor Promedio',
                    validate: {
                        required: true,
                    },
                    class: 'col-md-4',
                },
            ],

            HDMeta: [

                {
                    name: 'id',
                    title: 'ID',
                    sortField: 'id',
                    width: '10%',
                },
                {
                    name: 'periodo',
                    title: 'periodo',
                    sortField: 'periodo',
                    width: '20%',
                },
                {
                    name: 'codigoPrograma',
                    title: 'Codigo Programa',
                    sortField: 'codigoPrograma',
                    width: '20%',
                },
                {
                    name: 'entradas',
                    title: 'Entradas',
                    sortField: 'Entradas',
                    width: '5%',
                },
                {
                    name: 'mes',
                    title: 'mes',
                    sortField: 'mes',
                    width: '5%',
                },
                {
                    name: 'ano',
                    title: 'año',
                    sortField: 'año',
                    width: '5%',
                },
                {
                    name: 'tipoEstudiante',
                    title: 'tipo Estudiante',
                    sortField: 'tipoEstudiante',
                    width: '10%',
                },
                {
                    name: 'numero_Estudiante',
                    title: 'Numero Estudiante',
                    sortField: 'numeroEstudiante',
                    width: '10%',
                },
                {
                    name: 'valor_Facturado',
                    title: 'Valor Facturado',
                    sortField: 'valorFacturado',
                    width: '30%',
                },
                {
                    name: 'valor_Promedio',
                    title: 'Valor Promedio',
                    sortField: 'valorPromedio',
                    width: '20%',
                },
                {
                    name: '__slot:actions',
                    dataClass: 'text-right',
                    actionRef: [
                        {
                            label: 'Editar',
                            icon: 'fa-pencil',
                            action: 'edit',
                        },
                    ],
                },

            ],
            DLMetas: [],
            renderComponent1: false,
            renderComponent2: false,
            addRExito: false,
            UpdRExito: false,
            refNoUpdate: false,
            refWSUpdate: false,
            isNew: false,
        }
    },

    methods: {
        executeProcess: function (event, refer) {
            this.limpiaref()
            switch (event.target.id) {
                case 'btn_Sch_Button':
                    this.isNew = false
                    return new Promise((resolve, reject) => {
                        this.$refs.obsFieldsSearch.validate().then(results => {
                            if (!results) {
                                resolve(false)
                            } else {
                                this.searchForm()
                                resolve(true)
                            }
                        })
                    })
                case 'btn_Sch_ButtonNew':
                    this.limpiaref()
                    this.clearFields()
                    this.isNew = true
                    IberoHelpers.forceRerender2(this)
                    this.$modal.show('MetaModal')
            }
            this.$refs.obsFieldsSearch.validate()
        },

        searchForm() {
            document.getElementById('refNoData').classList.add('noShow')
            this.isNew = false
            let loader = this.$loading.show()
            var listMetas = IberoHelpers.GetGoals(this.$store, this.formSchModel, 0)
            console.log(listMetas)
            this.renderComponent1 = false
            listMetas.then(Response => {
                console.log(Response)
                if ((Response.data === undefined) || (Response.data === '')) {
                    console.log(`no pasó`)
                    document.getElementById('refNoData').classList.remove('noShow')
                } else {
                    console.log(`si pasó`)
                    console.log(Response)
                    if (Array.isArray(Response.data)) {
                        this.DLMetas = Response.data
                    } else {
                        this.DLMetas = [Response.data]
                    }
                    IberoHelpers.forceRerender1(this)
                }
                loader.hide()
            })
        },

        updatePeriod() {
            this.limpiaref()
            return new Promise((resolve, reject) => {
                this.$refs.obsFieldsUpdate.validate().then(results => {
                    if (!results) {
                        resolve(false)
                    } else {
                        let loader = this.$loading.show()
                        var totalinf = IberoHelpers.UpdateGoals(this.$store, this.formUpdModel)
                        totalinf.then(Response => {
                            this.renderComponent1 = false
                            if (Response === false) {
                                this.refWSUpdate = true
                                resolve(false)
                            } else if (!(Response.status === 200)) {
                                this.refNoUpdate = true
                                resolve(false)
                            } else {
                                this.UpdRExito = true
                                resolve(true)
                            }
                            this.$modal.hide('MetaModal')
                            this.searchForm()
                            loader.hide()
                        })
                    }
                })
            })
        },

        AddProgram() {
            this.limpiaref()

            return new Promise((resolve, reject) => {

                this.$refs.obsFieldsUpdate.validate().then(results => {
                    if (!results) {
                        resolve(false)
                    } else {

                        let loader = this.$loading.show()
                        var totalinf = IberoHelpers.InsertGoals(this.$store, this.formUpdModel)
                        totalinf.then(Response => {
                            this.renderComponent1 = false
                            if (Response === false) {
                                this.refWSUpdate = true
                                resolve(false)
                            } else if (!(Response.status === 200)) {
                                this.refNoUpdate = true
                                resolve(false)
                            } else {
                                this.addRExito = true
                                resolve(true)
                            }
                            this.$modal.hide('MetaModal')
                            this.searchForm()
                            loader.hide()
                        })
                    }
                })
            })
        },

        CancelUser() {
            this.limpiaref()
            this.clearFields()
            this.$modal.hide('MetaModal')
        },

        limpiaref() {
            this.addRExito = false
            this.UpdRExito = false
            this.refNoUpdate = false
            this.refWSUpdate = false
            document.getElementById('refNoData').classList.add('noShow')
        },

        clearFields() {
            this.formUpdModel.Periodo = ''
            this.formUpdModel.codigoPrograma = ''
            this.formUpdModel.Entradas = ''
            this.formUpdModel.Mes = ''
            this.formUpdModel.Ano = ''
            this.formUpdModel.TipoEstudiante = ''
            this.formUpdModel.Numero_Estudiante = ''
            this.formUpdModel.Valor_Facturado = ''
            this.formUpdModel.Valor_Promedio = ''
        },

        processData: function (dataInf, refdata) {
            this.limpiaref()
            this.isNew = false
            this.formUpdModel.id = dataInf.id
            this.formUpdModel.Periodo = dataInf.periodo
            this.formUpdModel.codigoPrograma = dataInf.codigoPrograma
            this.formUpdModel.Entradas = dataInf.entradas
            this.formUpdModel.Mes = dataInf.mes
            this.formUpdModel.Ano = dataInf.ano
            this.formUpdModel.TipoEstudiante = dataInf.tipoEstudiante
            this.formUpdModel.Numero_Estudiante = dataInf.numero_Estudiante
            this.formUpdModel.Valor_Facturado = dataInf.valor_Facturado
            this.formUpdModel.Valor_Promedio = dataInf.valor_Promedio
            IberoHelpers.forceRerender2(this)
            this.$modal.show('MetaModal')
        },
    },
    mounted() {
    },
}
</script>